export type TemplateReplacerMap = [from: string, to: string][];

const reducerFn = (accTmpl, [from, to]) =>
  accTmpl.replace(new RegExp(`\\${from}`, 'g'), to);

export function templateReplacer(template: string, map: TemplateReplacerMap): string {
  return map.reduce(reducerFn, template).replace(/\s+/g, ' ');
}
